import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators, FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "../../shared/services/auth.service";
import { CookieService } from "ngx-cookie-service";
const Swal = require("sweetalert2");

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styleUrls: ["./register.component.scss"],
})
export class RegisterComponent implements OnInit {
  public registerForm: FormGroup;
  public show: boolean = false;
  public showConfirm: boolean = false;
  public errorMessage: any;
  public cpf_cnpjMask = "000.000.000-00";

  mascararCpfCnpj(valor: string): string {
    let cleanedValue = valor.replace(/\D/g, "");

    if (cleanedValue.length <= 11) {
      // CPF
      if (cleanedValue.length <= 3) {
        return cleanedValue;
      } else if (cleanedValue.length <= 6) {
        return cleanedValue.replace(/^(\d{3})/, "$1.");
      } else if (cleanedValue.length <= 9) {
        return cleanedValue.replace(/^(\d{3})(\d{3})/, "$1.$2.");
      } else {
        return cleanedValue.replace(/^(\d{3})(\d{3})(\d{3})/, "$1.$2.$3-");
      }
    } else {
      // CNPJ
      if (cleanedValue.length <= 2) {
        return cleanedValue;
      } else if (cleanedValue.length <= 5) {
        return cleanedValue.replace(/^(\d{2})/, "$1.");
      } else if (cleanedValue.length <= 8) {
        return cleanedValue.replace(/^(\d{2})(\d{3})/, "$1.$2.");
      } else if (cleanedValue.length <= 12) {
        return cleanedValue.replace(/^(\d{2})(\d{3})(\d{3})/, "$1.$2.$3/");
      } else {
        return cleanedValue.replace(
          /^(\d{2})(\d{3})(\d{3})(\d{4})/,
          "$1.$2.$3/$4-"
        );
      }
    }
  }

  onCpfCnpjInput(event: any) {
    const input = event.target;
    const valor = input.value;
    const mascarado = this.mascararCpfCnpj(valor);
    this.registerForm
      .get("cpf_cnpj")
      ?.setValue(mascarado, { emitEvent: false });
  }

  constructor(
    private fb: FormBuilder,
    public router: Router,
    private authService: AuthService,
    private cookieService: CookieService
  ) {
    this.registerForm = this.fb.group(
      {
        nome: ["", [Validators.required, Validators.maxLength(255)]],
        login: [
          "",
          [
            Validators.required,
            Validators.maxLength(255),
            Validators.pattern(/^[^\s]+$/), // Não permite espaços
          ],
        ],
        senha: ["", [Validators.required, Validators.minLength(6)]],
        confirmarSenha: ["", [Validators.required]],
        email: [
          "",
          [Validators.required, Validators.email, Validators.maxLength(200)],
        ],
        telefone: ["", [Validators.required]],
        cpf_cnpj: ["", [Validators.required]],
        rua: ["", [Validators.required]],
        numero: ["", [Validators.required]],
        bairro: ["", [Validators.required]],
        cidade: ["", [Validators.required]],
      },
      { validators: this.passwordMatchValidator }
    );
  }

  ngOnInit() {}

  passwordMatchValidator(form: FormGroup) {
    const senha = form.get("senha");
    const confirmarSenha = form.get("confirmarSenha");

    if (senha && confirmarSenha && senha.value !== confirmarSenha.value) {
      confirmarSenha.setErrors({ passwordMismatch: true });
      return { passwordMismatch: true };
    }

    if (confirmarSenha && confirmarSenha.errors) {
      delete confirmarSenha.errors["passwordMismatch"];
      if (Object.keys(confirmarSenha.errors).length === 0) {
        confirmarSenha.setErrors(null);
      }
    }

    return null;
  }

  showPassword() {
    this.show = !this.show;
  }

  showConfirmPassword() {
    this.showConfirm = !this.showConfirm;
  }

  register() {
    if (!this.registerForm.valid) {
      this.showAlert(
        "error",
        "Por favor, preencha todos os campos corretamente."
      );
      return;
    }

    const {
      nome,
      login,
      senha,
      email,
      telefone,
      cpf_cnpj,
      rua,
      numero,
      bairro,
      cidade,
    } = this.registerForm.value;

    this.authService
      .criarUsuario(
        nome,
        login,
        senha,
        email,
        telefone,
        cpf_cnpj,
        rua,
        numero,
        bairro,
        cidade
      )
      .subscribe({
        next: (res) => {
          this.showAlert(
            "success",
            "Usuário criado com sucesso! Fazendo login..."
          );

          // Fazer login automático com as credenciais cadastradas
          this.authService.login(login, senha).subscribe({
            next: (loginRes) => {
              // Salvar dados do usuário no localStorage
              const userData = {
                nome: loginRes.nome || nome,
                token: loginRes.token || "",
                id: loginRes.id || 0,
                img: loginRes.img || "",
                empresa_id: loginRes.empresa_id || 0,
              };

              localStorage.setItem("user", JSON.stringify(userData));
              localStorage.setItem("token", userData.token);

              this.router.navigate(["/dashboard/default"]);
            },
            error: (loginErr) => {
              this.showAlert(
                "error",
                "Conta criada, mas erro no login automático. Faça login manualmente."
              );
              this.router.navigate(["/auth/login"]);
            },
          });
        },
        error: (err) => {
          let mensagem = "Erro ao criar usuário.";

          if (err.error) {
            if (err.error.message) {
              mensagem = err.error.message;
            }

            if (err.error.errors) {
              const errors = err.error.errors;
              if (errors.login && errors.login.length > 0) {
                const errorMsg = errors.login[0];
                if (errorMsg === "The login has already been taken.") {
                  mensagem =
                    "Este nome de usuário já está em uso. Escolha outro.";
                } else {
                  mensagem = errorMsg;
                }
              }
            }
          } else if (err.status === 422) {
            mensagem = "Dados inválidos. Verifique as informações.";
          }

          this.showAlert("error", mensagem);
        },
      });
  }

  showAlert(
    icon: "success" | "info" | "error",
    title: string,
    description?: string
  ) {
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });

    Toast.fire({
      icon: icon,
      title: title,
      text: description,
    });
  }
}
